import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/comensal-1-carta.webp")